import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Mes } from '@shared/models'
import { ClientesService } from '../../services/clientes.service'
import { Filters, lsAcompanharLancamentoSetor } from './models'
import * as toastr from 'toastr'
import * as moment from 'moment';

@Component({
  selector: 'app-acompanhar-lancamento-setor',
  templateUrl: './acompanhar-lancamento-setor.component.html',
  styleUrls: ['./acompanhar-lancamento-setor.component.css'],
})

export class AcompanharLancamentoSetorComponent implements OnInit {
  filters: Filters = {
    mesInicial: null,
    mesFinal: null,
    year: moment().year()
  }

  lsMeses: Mes[] = [];

  isLoading = false;
  lsAcompanharPrevisaoSetor:lsAcompanharLancamentoSetor[];

  showTable = false;

  vetorSetor: any;

  setorSelecionado: string = "";

  constructor(
    private router: Router,
    private clientesService: ClientesService,
  ) { }

  ngOnInit(){}

  onBack() {
    this.router.navigate(["/clientes/home/"]);
  }

  consult(){
    const { mesInicial, mesFinal, year } = this.filters;

    if(!mesInicial || !mesFinal){
      toastr.error("Campos 'do Mês' e 'Até o Mês' obrigatórios")
      return;
    }

    if(mesInicial.id > mesFinal.id ){
      toastr.error("O campo 'do Mês' deve ser anterior que o campo 'Até o Mês'")
      return;
    }

    // console.log("id selecionado", this.vetorSetor)
    if(this.vetorSetor == undefined){
      toastr.error("O campo 'Setor' é obrigatório'");
      return;
    }

    this.lsAcompanharPrevisaoSetor = []

    this.showTable = true
    this.isLoading = true

    const anoMesInitial = moment(new Date(year, mesInicial.id)).format('YYYYMM')
    const anoMesFinal = moment(new Date(year, mesFinal.id)).format('YYYYMM')

    this.clientesService.getAcopanharPrevisaoComSetor(anoMesInitial, anoMesFinal, this.vetorSetor.codigo)
      .finally(()=> this.isLoading = false )
      .subscribe(
        data => {
          const _lsAcompanharPrevisaoSetor:lsAcompanharLancamentoSetor[] = []

          data.map(item => {
            const index = _lsAcompanharPrevisaoSetor.findIndex( element => element.cdFzsRegional == item.codigoGerente )

            if(index == -1){
              _lsAcompanharPrevisaoSetor.push({
                cdFzsRegional:item.codigoGerente,
                data:[{
                  ...item
                }],
                qtdClientesAtivos:item.quantidadeSemPrevisao,
              })
            }else{
              _lsAcompanharPrevisaoSetor[index].qtdClientesAtivos += item.quantidadeSemPrevisao
              _lsAcompanharPrevisaoSetor[index].data.push(item)
            }
          })

          this.lsAcompanharPrevisaoSetor = _lsAcompanharPrevisaoSetor
        },
        error => {
          toastr.error('Ocorreu um erro ao carregar a lista de "Setores Sem Previsão"')
          console.log(error)
        }
      )
  }

  reset(){
    this.filters = {
      mesInicial: null,
      mesFinal: null,
      year: moment().year()
    }

    this.showTable=false
    this.lsAcompanharPrevisaoSetor = []
  }
}
